import React from 'react';
import { useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
// import { useAuth, useFetch } from "@recx/auth";
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { GlobalState } from '../../../../../../store/types';
import {
    getCaretIndex,
    isFirefox,
    updateCaret,
    insertNodeAtCaret,
    getSelection
} from '../../../../../../utils/contentEditable';
import classNames from 'classnames';
import { Tooltip } from 'primereact/tooltip';
import useFetch from 'hooks/useFetch';
import Hark from 'hark';
import { startRecording, stopRecording } from './recorderHelpers';

let bufferSize = 16384,
    context,
    processor,
    input,
    globalStream;

//const send = require('assets/images/send.svg') as string;
//const emoji = require('assets/images/icon-smiley.svg') as string;
const brRegex = /<br>/g;

//import "./style.scss";

type Props = {
    transcriptionAudioUrl: string;
    placeholder: string;
    disabledInput: boolean;
    autofocus: boolean;
    sendMessage: (event: any) => void;
    buttonAlt: string;
    onPressEmoji: () => void;
    onChangeSize: (event: any) => void;
    onTextInputChange?: (event: any) => void;
    loading?: boolean;
};

function Sender(
    {
        sendMessage,
        transcriptionAudioUrl,
        placeholder,
        disabledInput,
        autofocus,
        onTextInputChange,
        buttonAlt,
        onPressEmoji,
        onChangeSize,
        loading
    }: Props,
    ref
) {
    const showChat = useSelector((state: GlobalState) => state.behavior.showChat);
    // const inputRef = useRef<HTMLDivElement>(null!);
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const refContainer = useRef<HTMLDivElement>(null);
    const [enter, setEnter] = useState(false);
    const [firefox, setFirefox] = useState(false);
    const [height, setHeight] = useState(0);
    const [isRecording, setIsRecording] = useState(false);

    const [isStreaming, setIsStreaming] = useState(false);
    const [IsLoading, SetIsLoading] = useState(false);

    const audioContextRef = useRef();
    const mediaStream = useRef();

    useEffect(() => {
        if (!audioContextRef.current) {
            // @ts-ignore
            audioContextRef.current = new AudioContext();
            setup();
        }
        return () => {
            // @ts-ignore
            mediaStream.current?.getAudioTracks()[0].stop();
            // stopRecording({
            //   exportWAV: true,
            //   wavCallback: (blob) => {
            //     //handleBlobToBase64({ blob, continuous: false });
            //   },
            // });
            console.log('stopinnggg');
        };
    }, []);

    const { fetchData, loading: loadingTranscription, setLoading } = useFetch();

    // const [loading, setLoading] = useState(false)
    // const auth = useAuth();
    // const envLink = auth.settings.authority.split("/")[2];
    // const { post, loading } = fetch(`https://${envLink}/api/v6`);
    // @ts-ignore
    useEffect(() => {
        if (showChat && autofocus) {
            const el = inputRef.current;
            el.value = '';
            inputRef.current?.focus();
        }
    }, [autofocus, showChat]);
    useEffect(() => {
        setFirefox(isFirefox());
    }, []);

    useEffect(() => {
        if (!disabledInput) {
            inputRef.current?.focus();
            const el = inputRef.current;
            el.value = '';
        }
    }, [disabledInput, showChat]);

    useImperativeHandle(ref, () => {
        return {
            onSelectEmoji: handlerOnSelectEmoji
        };
    });

    const handlerOnChange = (event) => {
        onTextInputChange && onTextInputChange(event);
    };

    const handlerSendMessage = () => {
        const el = inputRef.current;
        if (el && el.value) {
            sendMessage(el.value);
            el.value = ''; // Clear the text content
        }
    };

    const handlerOnSelectEmoji = (emoji) => {
        const el = inputRef.current;
        const { start, end } = getSelection(el);
        if (el.innerHTML) {
            const firstPart = el.innerHTML.substring(0, start);
            const secondPart = el.innerHTML.substring(end);
            el.innerHTML = `${firstPart}${emoji.native}${secondPart}`;
        } else {
            el.innerHTML = emoji.native;
        }
        updateCaret(el, start, emoji.native.length);
    };

    const handlerOnKeyPress = (event) => {
        const el = inputRef.current;

        if (event.key === 'Enter' && event.shiftKey) {
            event.preventDefault();
            const start = el.selectionStart;
            const end = el.selectionEnd;
            const value = el.value;

            el.value = value.substring(0, start) + '\n' + value.substring(end);
            el.selectionStart = el.selectionEnd = start + 1;
        } else if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handlerSendMessage();
        }
    };

    // TODO use a context for checkSize and toggle picker
    const checkSize = () => {
        const senderEl = refContainer.current;
        if (senderEl && height !== senderEl.clientHeight) {
            const { clientHeight } = senderEl;
            setHeight(clientHeight);
            onChangeSize(clientHeight ? clientHeight - 1 : 0);
        }
    };

    const handlerOnKeyUp = (event) => {
        const el = inputRef.current;
        if (!el) return true;
        // Conditions need for firefox
        if (firefox && event.key === 'Backspace') {
            if (el.innerHTML.length === 1 && enter) {
                el.innerHTML = '';
                setEnter(false);
            } else if (brRegex.test(el.innerHTML)) {
                el.innerHTML = el.innerHTML.replace(brRegex, '');
            }
        }
        checkSize();
    };

    const handlerOnKeyDown = (event) => {
        const el = inputRef.current;

        // Handling Backspace key
        if (event.key === 'Backspace' && el) {
            const caretPosition = getCaretIndex(inputRef.current);
            const character = el.innerHTML.charAt(caretPosition - 1);
            if (character === '\n') {
                event.preventDefault();
                event.stopPropagation();
                el.innerHTML = el.innerHTML.substring(0, caretPosition - 1) + el.innerHTML.substring(caretPosition);
                updateCaret(el, caretPosition, -1);
            }
        }

        // Handling Enter key
        if (event.key === 'Enter' && event.shiftKey) {
            event.preventDefault();
            const start = el.selectionStart;
            const end = el.selectionEnd;
            const value = el.value;

            el.value = value.substring(0, start) + '\n' + value.substring(end);
            el.selectionStart = el.selectionEnd = start + 1;
        } else if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handlerSendMessage();
        }
    };

    const handlerPressEmoji = () => {
        onPressEmoji();
        checkSize();
    };

    const setup = async () => {
        // @ts-ignore
        context = new (window.AudioContext || window.webkitAudioContext)({
            // if Non-interactive, use 'playback' or 'balanced' // https://developer.mozilla.org/en-US/docs/Web/API/AudioContextLatencyCategory
            latencyHint: 'interactive',
            sampleRate: 16384
        });
        processor = context.createScriptProcessor(bufferSize, 1, 1);
        processor.connect(context.destination);
        context.resume();
        // processor.onaudioprocess = (e) => {
        //   // console.log({ e });
        //   left16 = microphoneProcess(e);
        // };
    };
    const StartRecording = async (transcription, continuous) => {
        // TimerCountDown()
        console.log('adasdsa');
        setIsStreaming(true);
        SetIsLoading(false);
        const stream = await startRecording({
            errHandler: () => console.error('Microphone permission was denied'),
            audioContext: audioContextRef.current
        });

        //const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        globalStream = stream;
        // input = context.createMediaStreamSource(stream);
        // input.connect(processor);

        if (mediaStream.current) {
            // @ts-ignore
            mediaStream.current.getAudioTracks()[0].stop();
        }

        // @ts-ignore
        // Clones stream to fix hark bug on Safari
        mediaStream.current = stream.clone();
        let timer;
        const speechEvents = Hark(mediaStream.current, {
            audioContext: audioContextRef.current
        });
        speechEvents.on('speaking', () => {
            // TimerCountDown();
            console.log('speaking');
            // if (timer) {
            //   clearTimeout(timer);
            // }
        });
        speechEvents.on('stopped_speaking', () => {
            console.log('stopped_speaking');
            // @ts-ignore
            if (clearTimeout(timer)) {
                timer = setTimeout(function () {
                    stop(true);
                }, 2000);
            }
        });
        // TimerCountDown()
        // console.log(mediaStream.current?.getAudioTracks()[0])
        // setTimeout(() => {
        //   stop()
        // }, "1000")

        // speechEvents.on("stopped_speaking", () => {
        //   console.log("stop speaking");
        //   mediaStream.current?.getAudioTracks()[0].stop();

        //   // Stops current recording and sends audio string to google cloud.
        //   // recording will start again after google cloud api
        //   // call if `continuous` prop is true. Until the api result
        //   // returns, technically the microphone is not being captured again
        //   stopRecording({
        //     exportWAV: true,
        //     wavCallback: (blob) => {
        //       handleBlobToBase64({ blob, continuous, transcription });
        //     },
        //   });
        // });
    };

    const handleBlobToBase64 = async ({ blob, continuous, transcription }) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        reader.onloadend = async () => {
            const base64data = reader.result;
            // @ts-ignore
            let sampleRate = audioContextRef.current?.sampleRate;
            if (sampleRate && sampleRate > 48000) {
                sampleRate = 48000;
            }
            const start = new Date();
            const starttime = start.getTime();


            const getLiveSentimentBody = (audio, pciRedaction) => {
                var request: any = {};
                request.isCompressionRequired = false;
                request.detailedResponseRequired = true;
                request.text = '';
                request.audioBytes = audio;
                request.features = {};
                request.features.transcription = {};
                request.features.sentiment = {};
                if (pciRedaction) {
                    request.features.redaction = {};
                }
                return request;
            };
            // @ts-ignore
            const body = getLiveSentimentBody(base64data.substr(base64data.indexOf(',') + 1), false);

            // setLoading(true);
            fetchData(`${transcriptionAudioUrl}/Live/AnalyzeLiveSentimentAnonymous`, body)
                .then((res) => {
                    if (res.status === 'success') {
                        //   setAudioStream(null);
                        //   setMediaRecorder(null);
                        setIsRecording(false);
                        // setAudioChunks([]);
                        const end = new Date();
                        const endtime = end.getTime();
                        //  transcription += res?.transcription;
                        // console.log(endtime)
                        const timeTaken = endtime - starttime;
                        setIsStreaming(() => false);
                        SetIsLoading(() => false);

                        inputRef.current.value += res.transcription;
                    } else {
                        setIsStreaming(() => false);
                    }

                    if (continuous) {
                        StartRecording(transcription, isStreaming);
                    }
                })
                .catch((err) => {
                    console.log({ err });
                })
                .finally(() => {
                    // setLoading(false);
                });

        };
    };

    const stop = (forceClose = false) => {
        if (isStreaming || forceClose) {
            console.log('stopppppppp');
            // @ts-ignore
            mediaStream.current?.getAudioTracks()[0].stop();
            stopRecording({
                exportWAV: true,
                wavCallback: (blob) => {
                    handleBlobToBase64({ blob, continuous: false, transcription: '' });
                }
            });
            SetIsLoading(() => true);
        }
    };

    return (
        <div
            style={{
                cursor: loading || disabledInput ? 'not-allowed' : 'auto'
                //  backgroundColor: (loading || disabledInput) && '#e5e7eb'
            }}
            ref={refContainer}
            className="rcw-sender --with-audio">
            <button aria-label='Emoji Selector' className="rcw-picker-btn" type="submit" onClick={handlerPressEmoji}>
                <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/icon-smiley.svg"} className="rcw-picker-icon" alt="" />
            </button>
            <div
                className={cn('rcw-new-message', {
                    'rcw-message-disable': disabledInput
                })}>
                <textarea
                    style={{
                        cursor: loading || disabledInput ? 'not-allowed' : 'auto',
                        backgroundColor: (loading || disabledInput) && '#e5e7eb'
                    }}
                    aria-label='User query'
                    className="rcw-input"
                    spellCheck
                    role="textbox"
                    disabled={loading || disabledInput || isStreaming}
                    ref={inputRef}
                    placeholder={`${placeholder}`}
                    onInput={handlerOnChange}
                    onKeyUp={handlerOnKeyUp}
                    onKeyDown={handlerOnKeyDown}
                    tabIndex={1}
                />
            </div>
            {/* <div className="audioInputs">
                <div className={'agent-button'}
                    onClick={() => {
                        if (isStreaming) {
                            console.log('stop');
                            stop();
                        } else {
                            console.log('start');
                            StartRecording('', true);
                        }
                    }}
                >
                    {!loadingTranscription && (
                        <>
                            <div
                                id="1"
                                className={classNames(`comment-mic`, {
                                    'mic--active': isStreaming
                                })}>
                                <div className="animation-outer"></div>

                                <Tooltip
                                    content={isStreaming ? 'Stop listening' : 'Use microphone'}
                                    target={'.comment-mic'}
                                    position="top"
                                />

                                <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/mic.svg"} alt="" />
                            </div>
                        </>
                    )}
                    {loadingTranscription && (
                        <>
                            <Tooltip content={'Processing'} target={'.mic-loader'} position="top" />
                            <div className="mic-loader">
                                <span></span>
                            </div>
                        </>
                    )}
                </div>
            </div> */}
            <button
                style={{
                    cursor: loading || disabledInput ? 'not-allowed' : 'auto'
                }}
                aria-label='Submit'
                type="submit"
                className="rcw-send"
                onClick={handlerSendMessage}
                tabIndex={2}>
                <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/send.svg"} className="rcw-send-icon" alt={buttonAlt} />
            </button>
        </div>
    );
}

export default forwardRef(Sender);
